import { Button } from '@iwoca/orion';
import classnames from 'classnames';

import styles from './CancelButton.module.css';

export const CancelButton = ({
  href,
  ...props
}: {
  href?: string;
} & React.HTMLAttributes<HTMLButtonElement>) => {
  if (!href) return null;

  const handleCancel = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    window.location.href = href;
  };

  return (
    <Button
      {...props}
      className={classnames(styles.cancelButton, props.className)}
      variant="tertiary"
      onClick={handleCancel}
    >
      Cancel order
    </Button>
  );
};
